import { useContext, useEffect } from 'react';

import { hot } from 'react-hot-loader/root';

import { CompanyContext } from 'common/containers/CompanyContainer';
import { useOnboardingContext } from 'common/containers/OnboardingContainer';
import { RouterContext } from 'common/containers/RouterContainer';
import { onboardingManager } from 'common/subdomain/admin/AdminOnboarding/InAppOnboarding/OnboardingManager';

const AdminHome = () => {
  const router = useContext(RouterContext);
  const company = useContext(CompanyContext);
  const { onboarding } = useOnboardingContext();

  useEffect(() => {
    const hasUncompletedSteps = onboardingManager.hasUnCompletedSteps(company, onboarding);

    if (hasUncompletedSteps) {
      router.replace('/admin/getting-started');
      return;
    }

    const isIDBEnabled = company?.featureAllowlist?.includes('idea-database');

    router.replace(isIDBEnabled ? '/admin/ideas' : '/admin/feedback');
  }, [router, company, onboarding]);

  return null;
};

export default hot(AdminHome);
